import React, { useContext, useState } from "react";
import styles from "./styles/PaymentSuccessPage.module.css";
import { useEffect } from "react";
import { UserData } from "../../../Context/DataContext";
import { useNavigate } from "react-router-dom";
import ok_img from "./styles/img/check.svg";
import logo from "./styles/img/logo.svg";
import success_img from "./styles/img/success_img.png";
import { LanguageContext } from "../../../Context/changeLanguageProvider";
import parse from "html-react-parser";
import useWindowDimensions from "../../Footer/footer";

function PaymentSuccessPage({ plan, user_id, transaction }) {
  const navigate = useNavigate();
  const userData = UserData();
  const { width } = useWindowDimensions();
  userData?.setFreezed(false);
  useEffect(() => {
    userData?.setFreezed(false);
    userData.getCustomerUser();
  }, []);
  const websiteCurrentLang = useContext(LanguageContext).language;
  const [dublicatedcontent, setDublicatedContent] = useState(
    websiteCurrentLang.content.DublicatedText
  );
  useEffect(() => {
    window.scrollTo(0, 0);
    setDublicatedContent(websiteCurrentLang.content.DublicatedText);
  }, [websiteCurrentLang]);
  useEffect(() => {
    setTimeout(() => {
      userData.getPromotionData();
    }, 1000);
  }, []);
  return (
    <div className={styles.main}>
      <div style={{ marginBottom: "30px" }}>
        <div className={styles.page_title}>
          {dublicatedcontent?.dublicatedText200}
        </div>
        {user_id && (
          <div
            className={styles.user_id_text}
          >{`${dublicatedcontent?.dublicatedText97}: ${user_id}`}</div>
        )}
      </div>

      <div className={styles.box}>
        <img className={styles.ok_img} src={ok_img} alt="ok" />

        <div className={styles.title}>
          {dublicatedcontent?.payment_successfull}
        </div>
        {plan && (
          <div className={styles.plan}>
            {dublicatedcontent?.you_are_now_subscribed} {plan}
          </div>
        )}
        {/* <div className={styles.transaction}>
                    Transaction Number: {transaction}
                </div> */}

        <div className={styles.big_title}>
          {width > 650
            ? parse(dublicatedcontent?.you_can_now_ensure)
            : dublicatedcontent.you_can_now_ensure_mobile}
        </div>

        <div
          className={styles.return_link}
          onClick={() => navigate("/user/dashboard", { replace: true })}
        >
          {dublicatedcontent?.return_to_dashboard}
        </div>

        <div className={styles.thanks}>
          {dublicatedcontent?.thanks_for_choosing}
        </div>

        <img className={styles.logo} src={logo} alt="Ostreon" />
        <div className={styles.inher}>INHERITANCE</div>
        <img className={styles.success_img} src={success_img} alt="Ostreon" />
      </div>
    </div>
  );
}
export { PaymentSuccessPage };
